module.exports = "mutation ($id: ID!) {\n  ProjectDelete(id: $id) {\n    id\n  }\n}\n"